import { connect } from 'react-redux'
import { pathOr, propOr, or, pickBy, findIndex, propEq } from 'ramda'

import { selectors } from '../../../Booking/provider'

import { setFirstSailDate, setSecondSailDate, getSelectedSailPackages } from '../../../../services/user-selections'
import { setEditedReservationData } from '../../../../services/reservation/actions/reservation.js'

import { showModal } from '../../../../actions'
import { modifyReservation, changeSailPackageByLeg } from '../../../Ticket/EditTicket/editTicketSagas'
import { fetchSailsForLegAndDate } from '../../../../services/schedule/actions/schedule'
import { fetchInventoryAction } from '../../../../services/inventory/actions'

import ModalEditDateTime from './ModalEditDateTime'
import { selectedSailBySailPackageCodeWhileEdit, selectIsRequestingDates } from '../../../../services/schedule/reducers'
import { getInventoryClassItemAmounts, inventoryCannotFitAmounts } from '../../../../services/inventory/utils'

function mapStateToProps(state) {
  const { selectedSailPackageIndexToEdit } = state
  const reservation = selectors.getEditReservation(state)
  const { reservationId, items, token } = reservation
  const {
    seqN,
    code: sailPackage,
    sailRefs = [],
  } = pathOr({}, ['sailPackages', [selectedSailPackageIndexToEdit]])(reservation)
  const packageCode = sailPackage || ''
  const selectedSail = or(selectedSailBySailPackageCodeWhileEdit(state)(packageCode), { sailPackage: packageCode })
  const sailRefIds = sailRefs.map((sailRef) => sailRef.sailRefId)
  const departureDates = sailRefs.map((sailRef) => sailRef.departureDate)
  const routeLegs = sailRefs.map((sailRef) => sailRef.routeLeg)
  const oldSailPackage = { sailPackage, seqN, sailRefIds, departureDates, routeLegs }
  const isRequestingDates = selectIsRequestingDates(state)

  const amounts = getInventoryClassItemAmounts(items)
  const amountsForIndex = pickBy((val, key) => key.startsWith(`${selectedSailPackageIndexToEdit}:`), amounts)

  const getAvailableInvClasses = selectors.availableInventoriesClassesBySailPackageCodeAndSailRefId()
  const inventory = getAvailableInvClasses(state, {
    code: selectedSail.sailPackage,
    sailRefId: selectedSail.sailRefId,
  })

  const capacityError = inventoryCannotFitAmounts(inventory, amountsForIndex, selectedSailPackageIndexToEdit)

  const selectedSailPackages = getSelectedSailPackages(state) || []
  const bookingOrderIndexRaw = findIndex(propEq('code', packageCode), selectedSailPackages)
  const bookingOrderIndex = bookingOrderIndexRaw >= 0 ? bookingOrderIndexRaw : selectedSailPackageIndexToEdit

  return {
    reservationId,
    reservationToken: token,
    selectedSailPackageIndexToEdit,
    bookingOrderIndex,
    selectedSail,
    oldSailPackage,
    availableReplacementLegs: selectors.getAvailableReplacementLegs(state),
    modalError: pathOr('', ['editTicket', 'modalError'])(state),
    isRequestingDates,
    capacityError,
    inventoryTaken: amountsForIndex,
    isFetching: state.fetching,
  }
}

const mapDispatchToProps = {
  changeSailPackageByLeg,
  modifyReservation,
  setFirstSailDate,
  setSecondSailDate,
  showModal,
  setEditedReservationData,
  fetchSailsForLegAndDate,
  fetchInventoryAction,
}

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const {
    selectedSailPackageIndexToEdit,
    bookingOrderIndex,
    oldSailPackage,
    reservationId,
    reservationToken,
    availableReplacementLegs,
    ...props
  } = stateProps
  const [initialDepartureDate] = oldSailPackage.departureDates

  const { selectedSail } = stateProps
  const { sailPackage: code, sailRefId } = selectedSail
  const selectedReplacementLeg = availableReplacementLegs.findIndex((sail) => sail.code === code)
  const sailPackage = { code }
  const [originalSailRefId] = oldSailPackage.sailRefIds
  const isNextAvailable = Boolean(sailRefId) && sailRefId !== originalSailRefId

  const [routeLeg] = oldSailPackage.routeLegs

  const selectDepartureDate = (date) => {
    const { setSecondSailDate, setFirstSailDate } = dispatchProps
    const selectDate = bookingOrderIndex ? setSecondSailDate : setFirstSailDate
    selectDate(date)

    if (routeLeg && oldSailPackage.sailPackage) {
      dispatchProps.fetchSailsForLegAndDate({ leg: routeLeg, date, code: oldSailPackage.sailPackage })
      dispatchProps.fetchInventoryAction({ leg: routeLeg, date, code: oldSailPackage.sailPackage })
    }
  }

  return {
    ...props,
    ...ownProps,
    sailPackage,
    isNextAvailable,
    selectedReplacementLeg,
    availableReplacementLegs,
    sailDate: initialDepartureDate,

    selectLeg(leg) {
      dispatchProps.changeSailPackageByLeg({ leg, selectedSailPackageIndexToEdit })
    },

    selectDepartureDate,

    applyChanges() {
      const { date, time } = propOr({}, 'departure')(selectedSail)
      const { routeLeg, sailRefId } = selectedSail

      if (routeLeg !== oldSailPackage.sailPackage) {
        return
      }

      const updateSailPackagesModification = {
        __type: 'updateSailPackages',
        ...oldSailPackage,
        updateSailPackage: {
          departureDate: date,
          departureTime: time,
          routeLeg,
          sailRefId,
        },
      }

      dispatchProps.modifyReservation({
        reservationToken,
        modifications: [updateSailPackagesModification],
      })
    },

    closeModal() {
      selectDepartureDate(initialDepartureDate)
      dispatchProps.showModal('')
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(ModalEditDateTime)
